import { NgModule } from '@angular/core';
import { CommonModule,DatePipe } from '@angular/common';
import {FlexLayoutModule} from '@angular/flex-layout';
import { UsersModule } from './users.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
//import { CdkVirtualForOf, ScrollingModule } from '@angular/cdk/scrolling';
 import { CoreModule } from '@angular/flex-layout';
 import {PrimeNgModule} from './primeng.module';
import { BottomSearchComponent,CmdmodelComponent,CmdmanufacturerComponent,CmdequipmentComponent,TicketSearchComponent,PartsSearchComponent,ResourcesSearchComponent } from '../components';
import { KeysearchComponent } from '../components/shared/keyLocationSearch/keysearch.component'
import { LocationcombosearchComponent } from '../components/shared/keyLocationSearch/locationcombosearch.component'
import {SafePipe} from '../pipes'
import { CustomDatePipe } from '../pipes';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
@NgModule({
  providers: [DatePipe],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    PrimeNgModule,
    UsersModule,
    NgbDropdownModule
    
    
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    PrimeNgModule,
    UsersModule,
    BottomSearchComponent, 
    LocationcombosearchComponent,
    KeysearchComponent,
    SafePipe,
    CustomDatePipe,
    CmdmodelComponent,
    CmdmanufacturerComponent,
    CmdequipmentComponent,ResourcesSearchComponent,NgbDropdownModule
  ],
  declarations: [
    BottomSearchComponent, KeysearchComponent, LocationcombosearchComponent,
    SafePipe,CmdmodelComponent,CmdmanufacturerComponent,CmdequipmentComponent,TicketSearchComponent,PartsSearchComponent,ResourcesSearchComponent,
    CustomDatePipe
  ],
 
})
export class SharedModule { }
